import { contrastRows } from "@/mocks/heiliao";

const verdictStyle: Record<string, string> = {
  打脸: "bg-primary-500 text-background-50",
  翻车: "bg-primary-500 text-background-50",
  存疑: "bg-accent-500 text-foreground-950",
};

export default function ContrastSection() {
  return (
    <section id="contrast" className="scroll-mt-20 bg-background-100/70 py-10 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 max-w-2xl">
          <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700">
            <i className="ri-focus-3-line text-sm"></i>细节对比
          </div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            说法 vs 实锤，摆在一起看
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            单看一边总有盲区。我们把当事人/团队对外说法与能找到的证据并排，差异一眼可见。
          </p>
        </div>

        <div className="mb-3 hidden grid-cols-[0.9fr_1.05fr_1.05fr_0.5fr] gap-3 px-2 text-xs font-bold tracking-wide text-foreground-400 md:grid">
          <span>事件焦点</span>
          <span>对外说法</span>
          <span>可核对证据</span>
          <span className="text-center">结论</span>
        </div>

        <div className="space-y-3">
          {contrastRows.map((r) => (
            <div
              key={r.issue}
              className="grid grid-cols-1 gap-3 rounded-xl border border-background-200 bg-background-50 p-4 md:grid-cols-[0.9fr_1.05fr_1.05fr_0.5fr] md:items-start md:gap-3"
            >
              <div className="flex items-center gap-2 font-bold text-foreground-950">
                <i className="ri-questionnaire-line text-primary-500"></i>
                <span className="text-sm leading-6">{r.issue}</span>
              </div>
              <div className="rounded-lg bg-secondary-100 px-3.5 py-3">
                <div className="mb-1 text-[11px] font-bold text-secondary-800">{r.claimType}</div>
                <p className="text-sm leading-6 text-foreground-800">{r.claim}</p>
              </div>
              <div className="rounded-lg bg-primary-50 px-3.5 py-3">
                <div className="mb-1 text-[11px] font-bold text-primary-700">{r.factType}</div>
                <p className="text-sm leading-6 text-foreground-800">{r.fact}</p>
              </div>
              <div className="flex items-center md:justify-center">
                <span
                  className={
                    "whitespace-nowrap rounded-full px-3 py-1 text-xs font-black " +
                    (verdictStyle[r.verdict] ?? "bg-secondary-200 text-secondary-900")
                  }
                >
                  {r.verdict}
                </span>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-information-line"></i>「存疑」仅指双方说法暂未定论，请等待更完整上下文。
        </p>
      </div>
    </section>
  );
}